// Libraries
var React = require('react');
var hdate = require('human-date');

// Components
var VideoModule = require('Video/VideoModule');

// Assets
var playIcon = require('../Video/play.svg');

// Styles
require('./ArticleLinkModule.scss');

class ArticleLinkModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			defaultMParticleEventObject: (typeof window !== "undefined") ? window.defaultMParticleEventObject : null,
			preview: true
		}
	}

	componentWillMount () {
		// Removes the Caption from he video so it fits in place.
		if (this.props.data
			&& this.props.data.article
			&& this.props.data.article.thumbnailType === 'VIDEO') {
			this.setState({
				media: { ...this.props.data.article.media, "hideCaption": true }
			});
		}
	}

	parseDateForTracking() {

		return this.props.data.article.date.slice(0,10);

	}

	parseTagsForTracking() {

		let result = '';
		let tags = [];

		if (this.props.data.article.tags.length) {

			for (let i = 0; i < this.props.data.article.tags.length; i++) {

				tags.push(this.props.data.article.tags[i].name);

			}

			return tags.join('|');

		}

		return result;

	}

	// Daylight saving time consideration
	articleDate() {
		const articleDateUtc = new Date(this.props.data.article.dateUtc);
		const relativeTimeObj = hdate.relativeTime(articleDateUtc, { returnObject: true});

		return relativeTimeObj.days <= 7
			? hdate.relativeTime(articleDateUtc)
			: articleDateUtc.getUTCDate() + ' ' + hdate.monthName(articleDateUtc) + ' ' + articleDateUtc.getUTCFullYear();
	}

	handleClick(event) {

		const shouldTrackWithMParticle = this.state.defaultMParticleEventObject !== null;

		if (shouldTrackWithMParticle) {

			const date = this.parseDateForTracking();
			const tags = this.parseTagsForTracking();

			const placementNameTarget = event.target.closest('[data-placement-name]');

			const eventData = {
				event: 'content_selected',
				content_publication_date: date,
				content_tags: tags,
				content_id: this.props.data.articleId,
				content_title: this.props.data.article.title,
				content_type: this.props.data.article.isVideoPage ? 'video' : 'article',
				placement_name: placementNameTarget ? placementNameTarget.getAttribute('data-placement-name') : 'other',
				placement_type: 'list',
				content_access_type: 'free' // dynamic in future
			};

			const eventDataMerged = {...this.state.defaultMParticleEventObject, ...eventData };
			window.dataLayer.push(eventDataMerged);

		}

	}

	render() {
		if (this.props.data && this.props.data.article) {
			const isVideoPage = this.props.data.article.isVideoPage;
			const images = this.props.data.article.image;
			const externalLink = this.props.data.article.media ? this.props.data.article.media.externalLink : null;
			const articleLink = externalLink ? externalLink : this.props.data.article.url;
			const linkMarkup = (
				<div className="ArticleLink__imageContainer">
					<a href={this.props.data.article.url} ref={(link) => { this.link = link; }} data-bg={images.smallUrlWebP + '*,*' + images.mediumUrlWebP + '*,*' + images.largeUrlWebP + '*,*' + images.extraLargeUrlWebP} className="ArticleLink__image" onClick={this.handleClick.bind(this)}>
						{this.props.isTrendingVideo &&
							<div className="ArticleLink__playIcon">
								<img src={playIcon} alt="" />
							</div>
						}
						{this.props.data.article.title}
					</a>
				</div>
			);

			return (
				<div className="ArticleLink">

					{this.props.data.article.thumbnailType === 'VIDEO' ? (
						<VideoModule data={this.state.media} articleLink={this.props.data.article.url} showPageLink={isVideoPage && this.props.data.article.showPageLink} publishedDate={this.props.data.article.date} />
					) : (
						linkMarkup
					)}
					
					
					<div className={`ArticleLink__info ${this.props.data.article.thumbnailType === 'VIDEO' ? 'ArticleLink__info--video' : ''}`}>
						<div className="ArticleLink__tags">
							{this.props.data.article.tags.map((item) => {
								return (
									<a className="ArticleLink__tag" rel="nofollow" href={item.url} key={item.id}>{item.hashtag}</a>
								);
							})}
						</div>
						{!isVideoPage || (this.props.data.article.showPageLink && isVideoPage) || externalLink ?
							<a href={articleLink} rel={externalLink ? 'noreferrer noopener' : undefined} target={externalLink ? '_blank' : undefined}><h3 className="ArticleLink__headline" onClick={this.handleClick.bind(this)}>{this.props.data.article.title}</h3></a>
							: <h3 className="ArticleLink__headline" data-target-url={this.props.data.article.url}>{this.props.data.article.title}</h3>
						}
						{this.props.data.article.hasDate &&
							<div className="ArticleLink__date">{this.articleDate()}</div>
						}
					</div>
				</div>
			)
		} else {
			return <div></div>;
		}
	}
}

module.exports = ArticleLinkModule;



// WEBPACK FOOTER //
// ./src/components/ArticleLink/ArticleLinkModule.js